<template>
  <div>
    <div class="content">
      <h4>易货产品</h4>
      <div>
        <span>产品名称</span>
        <input type="text" required v-model="channame">
      </div>
      <div class="shop-img">
        <span>产品图片</span>
        <uploadimg :uploadId="imgUrl2" :btnName="btnName2" v-model="imgUrl"></uploadimg>
        <!-- <input type="file" multiple="multiple" accept="image/png,image/jpg" required> -->
      </div>
      <div>
        <span>产品详情</span>
        <input type="text" required v-model="chandetail">
      </div>
      <div>
        <span>产品数量</span>
        <input type="text" required v-model="channum">
      </div>
      <div>
        <span>产品规格</span>
        <input type="text" required v-model="chanspec">
      </div>
      <div>
        <span>产品报价</span>
        <input type="text" required v-model="chanprice">
      </div>
      <div>
        <span>注意事项</span>
        <input type="text" required v-model="chantips">
      </div>
      <div>
        <span>产品其他情况</span>
        <textarea v-model="chanother"></textarea>
      </div>
    </div>
    <div class="content">
      <h4>需求产品</h4>
      <div>
        <span>产品名称</span>
        <input type="text" required v-model="needname">
      </div>
      <div>
        <span>产品详情</span>
        <input type="text" required v-model="needdetail">
      </div>
      <div>
        <span>产品规格</span>
        <input type="text" required v-model="needspec">
      </div>
      <div>
        <span>产品数量</span>
        <input type="text" required v-model="neednum">
      </div>
      <div>
        <span>期望价格</span>
        <input type="text" required v-model="needprice">
      </div>
      <div>
        <span>最晚交货时间</span>
        <input type="text" v-model="needtime">
      </div>
      <div>
        <span>其他需求</span>
        <textarea v-model="needother"></textarea>
      </div>
    </div>
    <div class="content">
      <h4>商家信息</h4>
      <div>
        <span>商家信息</span>
        <input type="text" required v-model="business">
      </div>
      <div>
        <span>联系人</span>
        <input type="text" required v-model="name">
      </div>
      <div>
        <span>联系方式</span>
        <input type="text" required v-model="phone">
      </div>
    </div>
    <div class="footer">
      <button type="submit" @click="handleReleaseClick">{{state}}</button>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import uploadimg from '@/common/uploadimg'
export default {
  name: 'ReleaseBusiness',
  props: {
    slist: Array
  },
  components: {
    uploadimg
  },
  data () {
    return {
      imgUrl2: 'uploadimg2',
      btnName2: '点击上传',
      state: '发布',
      channame: '',
      imgUrl: '',
      chandetail: '',
      channum: '',
      chanspec: '',
      chanprice: '',
      chantips: '',
      chanother: '',
      needname: '',
      needdetail: '',
      neednum: '',
      needspec: '',
      needprice: '',
      needtime: '',
      needother: '',
      business: '',
      name: '',
      phone: ''
    }
  },
  methods: {
    handleReleaseClick () {
      this.state = '发布中...'
      this.bus.$emit('loading', true)
      this.releaseyihuo()
      // 反馈
    },
    // 验证
    releaseyihuo () {
      this.axios.post('/ApiMe/ApplySupplyAndDemand', {
        SupplyName: this.channame, // 供给产品名称
        SupplyImg: $('#' + this.imgUrl2).val(), // 供给产品图片
        SupplyContent: this.chandetail, // 供给产品内容
        SupplyNumber: this.channum, // 供给产品数量
        SupplySpec: this.chanspec, // 供给产品规格
        SupplyPrice: this.chanprice, // 供给产品价格
        SupplyRemark: this.chantips, // 供给产品备注
        SupplySummary: this.chanother, // 供给产品其他信息
        DemandName: this.needname, // 需求产品名称
        DemandContent: this.needdetail, // 需求产品内容
        DemandSpec: this.needspec, // 需求产品规格
        DemandNumber: this.neednum, // 需求产品数量
        DemandPrice: this.needprice, // 需求产品价格区间
        DemandLastTime: this.needtime, // 需求最晚交货时间
        DemandSummary: this.needother, // 需求其他内容
        BusinessName: this.business, // 商家名称
        Linkman: this.name, // 联系人
        Telphone: this.phone // 联系电话
      }).then(this.postReleInfoSucc)
        .catch(this.postReleInfoFail)
    },
    // 提交
    postReleInfoSucc (res) {
      this.state = '再次发布'
      res = res.data
      if (res.errorInfo === '') {
        alert('发布成功')
        this.$router.push({
          path: '/me'
        })
      } else {
        alert(res.errorInfo)
      }
    },
    postReleInfoFail () {
      alert('发布失败')
    }
  }
}
</script>

<style scoped>
.content{ padding: 5px 15px; border-bottom: 5px solid #f2f2f2; padding-top: 0;}
.content input{ border: 1px solid #f2f2f2; height: 30px; margin-top: 5px; border-radius: 3px;}
.content .shop-img input{ border: 0;}
.content div{ margin-bottom: 5px; font-size: 14px; display: flex; justify-content: space-between; flex-direction: column;}
.content h4{ margin: 7px 0; color: #333; font-size: 16px; font-weight: bold;}
.content span{ color: #a6a6a6;}
.content textarea{ height: 100px; border: 1px solid #f2f2f2; margin-top: 5px; border-radius: 3px;}
textarea{ -webkit-appearance: none;}
.content .price div{ display: inline;}
.price input{ width: 30%;}
.footer{ padding: 15px 0;}
.footer button{ width: 80%; margin-right: auto; margin-left: auto; background-color: #ed2727; color: #fff; display: block; border: 0; height: 33px; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
</style>



// WEBPACK FOOTER //
// src/pages/release/components/Business.vue